// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextArea-module--text-area--1x9oD"};